// extracted by mini-css-extract-plugin
export var disabled = "_p-5";
export var error = "_p-1";
export var fitContent = "_p-6";
export var hasSuffix = "_p-4";
export var iconWrapper = "_p-b";
export var infoIconWrapper = "_p-d _p-b";
export var input = "_p-a";
export var inputWrapper = "_p-0";
export var large = "_p-8";
export var leadingIconWrapper = "_p-c _p-b";
export var measureBox = "_p-e";
export var medium = "_p-7";
export var readonly = "_p-2";
export var small = "_p-3";
export var suffix = "_p-9";